export const setTokenToUrl = (config) => {
  const token = localStorage.getItem("LANUP-TOKEN");
  if (!config.url.endsWith("login") && token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};
